import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import { getOfferImageLink } from 'lib/image';
import { toAbsoluteLink, toOfferLink } from 'lib/links';
import { formatOfferPageDescription, formatOfferPageTitle } from 'lib/offer';

const Head = ({
  aliasUrl = null,
  isIndexActive = true,
  offerPhoto,
  offerPrice,
  offerPriceType,
  offerPublished = null,
  offerTitle,
  storeDomain = null,
  storeName = null,
}) => {
  const description = formatOfferPageDescription({
    offerPublishedDate: offerPublished,
    storeUrl: storeDomain,
    offerTitle,
    offerPrice,
    storeName,
  });
  const offerPageTitle = formatOfferPageTitle({
    offerPrice,
    offerPriceType,
    offerTitle,
  });

  return (
    <NextSeo
      canonical={aliasUrl ? toAbsoluteLink(toOfferLink(aliasUrl)) : null}
      description={description}
      nofollow={!isIndexActive}
      noindex={!isIndexActive}
      openGraph={{
        title: offerPageTitle,
        description: description,
        images: [
          {
            url: getOfferImageLink(offerPhoto, 268),
            alt: offerPageTitle,
            height: 300,
            width: 300,
          },
        ],
      }}
      title={offerPageTitle}
    />
  );
};

Head.propTypes = {
  aliasUrl: PropTypes.string,
  isIndexActive: PropTypes.bool,
  offerPhoto: PropTypes.string.isRequired,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
  offerPublished: PropTypes.string,
  offerTitle: PropTypes.string.isRequired,
  storeDomain: PropTypes.string,
  storeName: PropTypes.string,
};

export default Head;
